<template>
    <div style="font-size: 14px; color: #0b58a2;">Is App</div>
</template>

<script>

    import setCordova from "../helpers/setCordova";

    export default {
        created() {
            this.$store.state.isApp = true;
            localStorage.setItem("app", 1);

            setCordova();

            this.$router.push("/");
        }
    }
</script>